import { defaultApplicationSettings } from "../store/applicationSettingsDefinitions";

/**
 * Overrides specific groups in defaultApplicationSettings with the provided values.
 * Must be called BEFORE initializeApplicationSettings so that the defaults used
 * during merge (and in early-return fallback paths) reflect the correct values
 * for the current boot context (e.g. Monarch vs web).
 */
export default function overrideDefaultApplicationSettings(overrides: Record<string, Record<string, unknown>>): void {
    for (const [group, values] of Object.entries(overrides)) {
        if (group in defaultApplicationSettings) {
            (defaultApplicationSettings as Record<string, any>)[group] = {
                ...(defaultApplicationSettings as Record<string, any>)[group],
                ...values,
            };
        }
    }
}
